import { createContext, useContext, useState } from 'react'

import _ from 'lodash'

const BottomSheetContext = createContext({})

export const useBottomSheetContext = () => useContext(BottomSheetContext)

export const BottomSheetProvider = ({ children }: any) => {
  const [_showBottomSheet, _setShowBottomSheet] = useState(false)
  const [contextProps, setContextProps] = useState({})

  const showBottomSheet = (props: any) => {
    if (props?.dontReplaceIfOpen && _showBottomSheet) return
    _setShowBottomSheet(props)

    setContextProps(
      props && _.isObject(props) && Object.keys(props).length > 0
        ? _.omit(props, ['component', 'onHide', 'onSave'])
        : {}
    )
  }
  const hideBottomSheet = () => showBottomSheet(false)

  const BottomSheet = ({ component, onHide, onSave, ...rest }: any) => {
    const Component = component

    return (
      <Component
        {...rest}
        onHide={onHide}
        open={!!_showBottomSheet}
        onDismiss={() => {
          hideBottomSheet()
          onHide?.()
        }}
        onSave={(record: any) => {
          hideBottomSheet()
          onSave && onSave(record)
        }}
      />
    )
  }

  return (
    <BottomSheetContext.Provider
      value={{
        ...contextProps,

        modalIsOpen: !!_showBottomSheet,
        showBottomSheet,
        hideBottomSheet
      }}
    >
      {children}

      {_showBottomSheet && (
        <BottomSheet
          {...(typeof _showBottomSheet === 'object' ? _showBottomSheet : {})}
        />
      )}
    </BottomSheetContext.Provider>
  )
}

export const withBottomSheet = (Component: any) => {
  const WrappedComponent = (props: any) => {
    return (
      <BottomSheetProvider>
        <Component {...props} />
      </BottomSheetProvider>
    )
  }

  WrappedComponent.displayName = `withBottomSheet(${
    Component.displayName || Component.name
  })`

  return WrappedComponent
}
